import React from 'react';

import { ArticleWrapper } from './styles/ArticleStyles';

const Article = ({ 
  link, 
  text, 
  overlay
}) => (
  <ArticleWrapper overlay={overlay}>
    <a href={link}>{text}</a>
  </ArticleWrapper>
);

export default Article;